import { Col, Container, Row } from "react-bootstrap";
import classes from "./QuickStart.module.scss"
import Button from "../components/UI/Button";
import ProgressBar from "../components/formWizardOverride/ProgressBar";
import ProgressBarIntegration from "../components/formWizardOverride/ProgressBarIntegration";
import { NavLink } from "react-router-dom";
import { UserUIStateContext } from "../store/userUIStateContext";
import { useContext, useEffect, useState } from "react";
import TinyProgressBar from "../components/formWizardOverride/TinyProgressBar";
import { OrgIdContext, ClientTypes } from "../store/orgId_context";
import BusinessIcon from '@mui/icons-material/Business';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import StorageIcon from '@mui/icons-material/Storage';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import ReceiptIcon from '@mui/icons-material/Receipt';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import BugReportIcon from '@mui/icons-material/BugReport';
import MoreIcon from '@mui/icons-material/More';

const QuickStart = () => {
    const {clientWizardStep, integrationWizardStep, clientWizardFinished,serverDataLoaded, integrationData} = useContext(UserUIStateContext);
    const {clientType, isTransformer, isIntegrator } = useContext(OrgIdContext);
    const [clientWizardSteps, setClientWizardSteps] = useState(["Information", "Distribution", "Package", "SLA", "Production"]);
    const [integrationWizardSteps, setIntegrationWizardSteps] = useState(["Overview", "Invoice", "Execute", "View", "What's next"]);
    const [showIntegration, setShowIntegration] = useState(false);
    const [currentStep, setCurrenStep] = useState();
    const [completed, setCompleted] = useState();

    useEffect(() => {
        /*if(clientType === ClientTypes.ISV)
            setClientWizardSteps(["Information", "Distribution", "Clients", "Package", "Production"]);*/
    }, [clientType]);
    useEffect(() => {
        if(!integrationData)
        return;
        if(integrationData.integrationWizardCompleted)
            setCompleted(true);

        if(integrationData.integrationWizardCompleted ===true){
            setCurrenStep(5)
        }else if(integrationData.executeCompleted  ===true){
            setCurrenStep(4)
        }else if(integrationData.invoiceCompleted  ===true){
            setCurrenStep(3)
        }else if(integrationData.overviewCompleted  ===true){
            setCurrenStep(2)
        }else if(integrationData.firstRun){
            setCurrenStep(1);
        }
        
    }, [integrationData, serverDataLoaded]);

    useEffect(() => {
        if(isTransformer || isIntegrator || clientType === ClientTypes.ISV){
            setShowIntegration(true);
        }else{
            setShowIntegration(false);
        }
    }, [isTransformer, isIntegrator, clientType])
    return (
        <>
        <Container className={classes["main-wrapper"]}>
            <Row>
                <Col>
                    <h4 class={`${classes["mainTitle"]} display-6 font-weight-bolder`}>Step by step quick setup guide</h4>
                </Col>
            </Row>
            <Row style={{padding:"3rem", justifyContent:"center"}}>
                {showIntegration && 
                <Col className="col-md-6 col-sm-12 col-12">
                    <Container className={`${classes["container"]} d-flex flex-column`} style={{height:"100%"}}>
                        <Row className={classes["titleRow"]}>
                            <Col className="col-1 p-1">
                                <IntegrationInstructionsIcon/>
                            </Col>
                            <Col>
                                <div className={classes["titleBadge"]}>Learn basic integration</div>
                            </Col>
                            <Col className="col-1" style={{paddingLeft:"0px", paddingTop:"0.25rem"}}>
                                <IntegrationInstructionsIcon/>
                            </Col>
                        </Row>
                        <Row style = {{padding:"1rem", textAlign:"left"}}>
                            <p>Go through the following processes to learn about the basics of integrating invoice handling in your solution.</p>
                            <p>In this process you will learn to:</p>
                            <ul className={`${classes["pricing-table-ul"]} ${classes["integration"]}`} >
                                <li><ReceiptIcon className={classes["fa"]}/>Learn the basic information needed about an invoice</li>
                                <li><StorageIcon className={classes["fa"]}/>Which steps should your invoice complete with the state authority</li>
                                <li><FileCopyIcon className={classes["fa"]}/>How the determine which documents you want our services to return</li>
                                <li><BugReportIcon className={classes["fa"]}/>Sending a <u>test</u> invoice to our services</li>
                                <li><MoreIcon className={classes["fa"]}/>And further detailed information, to find what fits your needs</li>
                            </ul>
                        </Row>
                        <Row>
                            {/* <ProgressBarIntegration progress={integrationWizardStep}></ProgressBarIntegration> */}
                            <TinyProgressBar steps={integrationWizardSteps} progress={currentStep} finished={completed}/>
                        </Row>
                        <Row className="mt-auto" style={{textAlign:"right", padding:"1rem"}}>
                            <Col>
                                <NavLink to="/integration-wizard">
                                    <Button>{currentStep===undefined ? "Start" : "Continue"}</Button>
                                </NavLink>
                            </Col>
                        </Row>
                    </Container>
                </Col>}
                <Col className="col-md-6 col-sm-12 col-12">
                    <Container className={`${classes["container"]} d-flex flex-column`} style={{height:"100%"}}>
                        <Row className={`${classes["titleRow"]} ${classes["titleCompany"]}`}>
                            <Col className="col-1 p-1">
                                <BusinessIcon/>
                            </Col>
                            <Col>
                            <div className={classes["titleBadge"]}>Setup my company</div>
                            </Col>
                            <Col className="col-1" style={{paddingLeft:"0px", paddingTop:"0.25rem"}}><BusinessIcon/></Col>
                        </Row>
                        <Row style = {{padding:"1rem", textAlign:"left"}}>
                            <p>Start by setting up the <u>minimally</u> required information for your company. By finishing this quick-start course, you will
                            be able to already start using our services using your real information.</p>
                            <p>In this process you will finish:</p>
                            <ul className={`${classes["pricing-table-ul"]} ${classes["profile"]}`} >
                                <li><PermContactCalendarIcon className={classes["fa"]}/>Necessary information of your company</li>
                                <li><StorageIcon className={classes["fa"]}/>Services information to communicate with the state authorities</li>
                                <li><ToggleOnIcon className={classes["fa"]}/>Finishing up with moving your company to production mode and ready to be send and recieve invoices</li>
                            </ul>
                        </Row>
                        <Row style = {{padding:"1rem", textAlign:"left"}}>
                            Completed:
                        </Row>
                        <Row>
                            <Col>
                            {/* <ProgressBar progress={clientWizardStep}></ProgressBar> */}
                            <TinyProgressBar steps={clientWizardSteps} progress={clientWizardStep} finished={clientWizardFinished}/>
                            </Col>
                        </Row>
                        <Row className="mt-auto" style={{textAlign:"right", padding:"1rem"}}>
                            <Col>
                                <NavLink to="/client-init">
                                    <Button>{clientWizardStep===null ? "Start" : "Continue"}</Button>
                                </NavLink>
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>
            
        </Container>
        </>
    )
}

export default QuickStart;